import { CommunicationSizeComponent, ComponentIds } from '@inter-ikea-core/core';
import { CoreApi, ProductType } from '@inter-ikea-storageone/range';

export const selectedEntityIsNotClothRail = (coreApi: CoreApi): boolean => {
  const selectedProduct = coreApi.entities.findSelectedEntity();
  if (!selectedProduct) {
    return false;
  }
  return !coreApi.entities.isProductType(
    selectedProduct,
    ProductType.JONAXEL_CLOTH_RAIL_ADJUSTABLE
  );
};

export const selectedEntityIsBigShelvingUnit = (coreApi: CoreApi): boolean => {
  const selectedProduct = coreApi.entities.findSelectedEntity();
  if (!selectedProduct) {
    return false;
  }
  if (!coreApi.entities.isProductType(selectedProduct, ProductType.JONAXEL_FRAME_SHELF)) {
    return false;
  }

  const shelvingUnitWidth = selectedProduct.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size.width;

  return shelvingUnitWidth === 800;
};

export const selectedFrameHasShelvingCounterpart = (coreApi: CoreApi): boolean => {
  const selectedProduct = coreApi.entities.findSelectedEntity();
  if (!selectedProduct) {
    return false;
  }
  if (!coreApi.entities.isProductType(selectedProduct, ProductType.JONAXEL_FRAME)) {
    return false;
  }

  const size = selectedProduct.getComponent<CommunicationSizeComponent>(
    ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID
  )?.size;

  return size?.height !== 700;
};

export const framesInScene = (coreApi: CoreApi): boolean => {
  const framesInScene = coreApi.entities.getByComponents([ComponentIds.FRAME_COMPONENT_ID]);
  return framesInScene.some(e => coreApi.entities.isProductType(e, ProductType.JONAXEL_FRAME));
};
